define('views/modules/dashboard/activities/activities',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    'services/events/calendar-events',
    // models & collections
    'collections/calendar/days',
    'collections/calendar/items',
    // views
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-add-list',
    'views/parts/form/button',
    'views/modules/calendar/calendar/calendar-component/item/add-calendar-item-today',
    'views/modules/calendar/calendar/calendar-component/modal/calendar-session-print-modal',
    // modals
    'views/modules/calendar/calendar/calendar-component/item/item-move-modal',
    // Templates
    'text!templates/modules/dashboard/activities/activities.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    i18n,
    CalendarEvents,
    // models & collections
    CCalendarDays,
    CCalendarItems,
    // views
    VCalendarItemAddList,
    VButton,
    VAddCalendarItemToday,
    VCalendarSessionPrintModal,
    // modals
    VCalendarItemMoveModal,
    // Templates
    TActivities
) {

    var VActivities = Backbone.View.extend({
        template: TActivities,

        regions: {
            today: ".today-list",
            addCalendarItemToday: '.add-calendar-item-today',
            next: "#next-assignments",
            missed: "#missed-assignments",
            noActivity: ".no-activity",
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                collection: new CCalendarDays(),
                items: new CCalendarItems(),
                missedItems: new CCalendarItems(),
                todayItems: new CCalendarItems(),
                nextItems: new CCalendarItems(),
            });

            this.setUrl('dashboardCalendar', '#/' + opt.url.dashboard + 'calendar/');
            this.setUrl('calendar', '#/' + opt.url.calendar);

            var model = this.model,
                view = this.view = {
                    missed: new VCalendarItemAddList({
                        collection: this.missedItems,
                        title: 'Missed',
                        summary: false,
                        async: false,
                        role: opt.role,
                        url: this.url.dashboardCalendar
                    }),
                    today: new VCalendarItemAddList({
                        collection: this.todayItems,
                        title: 'Today',
                        async: false,
                        summary: false,
                        role: opt.role,
                        url: this.url.dashboardCalendar
                    }),
                    addCalendarItemToday: new VAddCalendarItemToday(this.url.dashboardCalendar),
                    next: new VCalendarItemAddList({
                        collection: this.nextItems,
                        title: 'Upcoming assignments',
                        async: false,
                        role: opt.role,
                        url: this.url.dashboardCalendar
                    }),
                };

            var todayUrl = this.url.dashboardCalendar + moment().format('YYYY-MM-DD');
            this.setUrl('activity', todayUrl + '/activity/');
            this.setUrl('nutrilog', todayUrl + '/nutrilog/');

            this.listenTo(this.missedItems, {
                'update reset': this.onMissedItemsUpdate,
                'sync': this.onMissedItemsSync
            });

            this.listenTo(this.items, {
                "add": this.onNewItem,
                "change:date": this.onItemDateChange,
                "item:print": this.onPrintItem
            });

            this.listenTo(this.nextItems, { 'update reset': this.onNextItemsUpdate });
            this.listenTo(this.todayItems, { 'update reset': this.onTodayItemsUpdate, });
            this.listenTo(this.collection, { 'sync': this.onCollectionSync });

            this.listenTo(this.todayItems, { 'sync': this.updateWeekStats, 'item:move:modal': this.onMoveModalAction });
            this.listenTo(this.nextItems, { 'sync': this.updateWeekStats, 'item:move:modal': this.onMoveModalAction });
            this.listenTo(this.missedItems, { 'sync': this.updateWeekStats, 'item:move:modal': this.onMoveModalAction });

            this.listenTo(this.todayItems, 'all', function() {
               CalendarEvents.onNewItemToday();
            });
        },

        render: function() {
            this.initListener();
            var url = this.url;
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                activityUrl: url.activity,
                nutrilogUrl: url.nutrilog,
                calendarUrl: url.calendar
            })));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.today, zone.$today)
                .assign(view.addCalendarItemToday, zone.$addCalendarItemToday)
                .assign(view.next, zone.$next)
                .assign(view.missed, zone.$missed);

            this.fetchDays();

            return this;
        },

        initListener: function() {
            this.stopListeningTo(CalendarEvents);
            this.listenTo(CalendarEvents, {
                'item:update': this.onItemUpdate,
                'session:update': this.onSessionUpdate,
            });
        },


        fetchDays: function() {
            this.collection.fetch({
                date: moment().subtract(1, 'weeks'),
                count: 100,
                user: this.model.id,
            });
        },

        resetItems: function() {
            var items = this.items;
            items.reset(this.collection.getAllItems());

            this.missedItems.reset(items.filter(function(item) {
                return item.getDate().isBefore(moment(), 'day') && !item.isDone();
            }).slice(0, 3));

            this.todayItems.reset(items.filter(function(item) {
                return moment().isSame(item.getDate(), 'day');
            }));

            this.nextItems.reset(items.filter(function(item) {
                return item.getDate().isAfter(moment(), 'day');
            }).slice(0, 3));
        },

        updateWeekStats: function() {
          this.trigger("dashboard.activity:update");
        },

        toggleNextItems: function() {
            this.view.next.toggle(Boolean(this.nextItems.length));
            return this;
        },

        toggleMissedItems: function() {
            this.view.missed.toggle(Boolean(this.missedItems.length));
            return this;
        },

        toggleTodayItems: function() {
            var hasTodayActivity = Boolean(this.todayItems.length);
            this.zone.$noActivity.toggle(!hasTodayActivity);
            this.view.today.toggleList(hasTodayActivity);
            return this;
        },

        onCollectionSync: function(collection) {
            this.resetItems();
        },

        onTodayItemsUpdate: function(collection) {
            this.toggleTodayItems();
        },

        onNextItemsUpdate: function(collection) {
            this.toggleNextItems();
        },

        onMissedItemsUpdate: function(collection) {
            this.toggleMissedItems();
        },

        onMissedItemsSync: function(model) {
            if (model.isDone()) {
                this.missedItems.remove(model);
            }
        },

        onItemDateChange: function(model, value, options) {
            var oldDate = model.previousAttributes().date,
                removeList = this.getListByDate(oldDate),
                addList = this.getListByDate(value);

            removeList.remove(model);

            if (addList !== this.missedItems) { // We don't add items to missedItems because past items are considered as done
                addList.add(model);
            }
        },

        onItemUpdate: function(model) {
            this.items.set(model, { remove: false }); // only update
        },

        onSessionUpdate: function(session, origin) {
            var items = this.items;
            items.updateSession(session);

            // adds the new items
            if (session.hasReceivedChanges()) {
                var added = session.getReceivedChanges().added;
                items.add(added);
            }
        },

        onNewItem: function(model, collection, options) {
            var addList = this.getListByDate(model.getDate());
            if (addList && addList !== this.missedItems) {
                addList.add(model);
            }
        },

        getListByDate: function(date) {
            date = moment(date);
            var today = moment(),
                twoWeeksAfter = moment().add(2, 'weeks'),
                twoWeeksBefore = moment().subtract(2, 'weeks');

            if (date.isSame(today, 'day')) {
                return this.todayItems;
            } else if (date.isBetween(today, twoWeeksAfter)) {
                return this.nextItems;
            } else if (date.isBetween(twoWeeksBefore, today)) {
                return this.missedItems;
            }
        },

        onDisable: function() {
            this.stopListeningTo(CalendarEvents);
        },

        onMoveModalAction: function(model) {
            var move = this.view.move || new VCalendarItemMoveModal();
            move.setModel(model).render();
        },

        onPrintItem: function(model) {
            var view = this.view,
                modal = view.sessionPrint || (view.sessionPrint = new VCalendarSessionPrintModal());
            modal.setModel(model).fetchRelatedSession();
        },

    });

    return VActivities;

});

